import { CheckCircle2 } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { StaggerGroup, StaggerItem } from "@/components/motion";
import { WHAT_TO_EXPECT } from "@/data/site";

export default function WhatToExpect() {
  return (
    <section data-testid="what-to-expect" className="bg-[#FEF7F2] py-8">
      <div className="nc-container">
        <SectionHeading
          eyebrow="What To Expect"
          title="What working with North Cadence looks like."
          subtitle="North Cadence is a new firm. We don't have client testimonials yet — and we won't fabricate them. What we can tell you is exactly what you'll experience when you work with us."
        />

        <StaggerGroup className="mt-14 grid gap-6 md:grid-cols-2">
          {WHAT_TO_EXPECT.map((item, i) => (
            <StaggerItem key={item.title}>
              <div
                data-testid={`expect-${i}`}
                className="flex h-full flex-col gap-3 rounded-3xl border border-[#e7e9ef] bg-white p-8"
              >
                <CheckCircle2 className="h-8 w-8 text-[#2FA86A]" />
                <h3 className="mt-2 font-display text-xl font-bold text-[#1B1B1B]">{item.title}</h3>
                <p className="text-[15px] leading-relaxed text-[#1B1B1B]/60">{item.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>

        <p className="mx-auto mt-14 max-w-3xl text-center text-[15px] leading-relaxed text-[#1B1B1B]/55">
          We are building our client story with every engagement we take on. If you work
          with us now, you get the founding team's direct attention, their genuine
          commitment to your outcome, and pricing that reflects where we are in our
          journey. We'll earn your testimonial by delivering results — not by asking you
          to take our word for it.
        </p>
      </div>
    </section>
  );
}
